import { AssertionError } from "./errors/index.js";
export function isDeletableGridModel(model) {
  return (model === null || model === void 0 ? void 0 : model.isDeletable) !== undefined;
}
export function assertIsDeletableGridModel(model) {
  if (!isDeletableGridModel(model)) {
    throw new AssertionError("Expected 'model' to be deletable, but received ".concat(model));
  }
}

/**
 * Model for a deletable grid
 */
//# sourceMappingURL=DeletableGridModel.js.map